import CountUp from "react-countup";
import counter_icons from "../../../../constants/infoCounterIcons.constant";
import info_counters from "../../../../constants/infoCounters.constant";
import styles from "./InformationsCounterSection.module.scss";

const InformationsCounterSection = () => {
  return (
    <section id={styles.info_counter_section}>
      <div className={styles.info_counters_container}>
        {info_counters.map((element: any, idx: number) => {
          const icon = counter_icons[idx];
          return (
            <div key={idx} className={styles.info_counter}>
              <div className={styles.info_details}>
                <h1 className={styles.count}>
                  <CountUp duration={2.75} end={element.count} />
                </h1>
                <p className={styles.title}>{element.title}</p>
              </div>
              <div className={styles.counter_icon}>
                {icon && <img src={icon.icon} alt={"counter icon"} />}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default InformationsCounterSection;
